import { useGlobalContext } from '../context/GlobalContext';
import { useEffect } from 'react';
import Loading from './Loading';
import Lesson from './Lesson';
import Alert from './Alert';
import PageBtnContainer from './PageBtnContainer';
import styled from 'styled-components';

const LessonsContainer = () => {
  const {
    getLessons,
    lessons,
    isLoading,
    page,
    totalLessons,
    search,
    searchStatus,
    searchType,
    sort,
    numOfPages,
    showAlert,
  } = useGlobalContext();

  useEffect(() => {
    getLessons();
    // eslint-disable-next-line
  }, [page, search, searchStatus, searchType, sort]);
  if (isLoading) {
    return <Loading center />;
  }

  if (lessons.length === 0) {
    return (
      <div>
        <h2>No lessons to display...</h2>
      </div>
    );
  }

  return (
    <LessonContainer>
      <div>
        {showAlert && <Alert />}
        <h5>
          {totalLessons} Lesson{lessons.length > 1 && 's'} found
        </h5>
        <div className='lessons'>
          {lessons.map((lesson) => {
            return <Lesson key={lesson._id} {...lesson} />;
          })}
        </div>
        {numOfPages > 1 && <PageBtnContainer />}
      </div>
    </LessonContainer>
  );
};

const LessonContainer = styled.section`
  margin-top: 4rem;
  h2 {
    text-transform: none;
  }
  & > h5 {
    font-weight: 700;
  }
  .jobs {
    display: grid;
    grid-template-columns: 1fr;
    row-gap: 2rem;
  }
  @media (min-width: 992px) {
    .jobs {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 1rem;
    }
  }
`;

export default LessonsContainer;
